export default __webpack_public_path__ + "static/media/Head_2_Ear_1_C4.8ef90145.svg";